module.exports = __webpack_public_path__ + "img/clubhouse.57eee2e0.jpg";